export const environment = {
    production: true,
    APIUrl: 'https://localhost:3000',
};
